import Button from "@material-ui/core/esm/Button";
import clsx from 'clsx';
import React from 'react';
import Spinner from 'components/Spinner/Spinner';
import useStyles from './ButtonStyles';
export default function PrimaryButton({
  className,
  children,
  disabled,
  loading,
  onClick,
  startIcon,
  endIcon
}) {
  const {
    primaryButton,
    wrapper
  } = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: clsx({
      [wrapper]: loading
    })
  }, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    variant: "contained",
    className: clsx(primaryButton, className),
    disabled: loading || disabled,
    onClick: onClick,
    startIcon: startIcon,
    endIcon: endIcon
  }, children), loading && /*#__PURE__*/React.createElement(Spinner, {
    isButtonProgress: true
  }));
}
PrimaryButton.defaultProps = {
  disabled: false,
  className: '',
  loading: false,
  startIcon: undefined,
  endIcon: undefined
};